import React from 'react';
import {observer} from 'mobx-react';
import {RenderV2_DisplayItem} from '../render-v2-d';
import './mat-secondary.scss';
import {FrameBuilderStore} from '../frame-builder-store';

type Props = {
    item: RenderV2_DisplayItem;
    store: FrameBuilderStore;
};

export const MatSecondary = observer(({item, store}: Props) => {
    const containerStyle = store.containerStyle(item);
    const docStyle = store.documentStyle(item);

    if (item.mat2ImageURL) {
        const matImages = store.matImageElements(item);

        return (
            <div
                style={containerStyle}
                className="mat-image-container"
            >
                {matImages.map(({id, src, style}) => (
                    <img
                        key={id}
                        id={id}
                        src={src}
                        alt={id.replace('mat2_', '').replace('_', ' ')}
                        style={{position: 'absolute', height: 'fit-content', ...style}}
                    />
                ))}

                <img
                    id="document"
                    src={item.url}
                    alt="Document"
                    style={docStyle}
                />
            </div>
        );
    }

    const matBoxes = store.matBoxElements(item);
    const {inchToPx} = store;

    return (
        <div
            style={containerStyle}
            className="frame-doc-container"
        >
            {matBoxes.map(({cls, w, h, extra}) => (
                <div
                    key={cls}
                    className={cls}
                    style={{width: inchToPx(w), height: inchToPx(h), ...extra}}
                />
            ))}

            <img
                src={item.url}
                alt="Document"
                className="absolute-center"
                style={docStyle}
            />
        </div>
    );
});
